<style lang="scss">
  @import '../resources/scss/project_impact.scss';
</style>

<script lang="ts">
  import type ProjectResultsSection from '../api/rest/directus-cms/projects/model/ProjectResultsSection'
  import Metric from './Metric.svelte'
  import { Darkness } from '../config/colors'

  export let color_class: string
  export let resultsSection: ProjectResultsSection
  const title = resultsSection.translations[0].title
</script>

<div class="container-fluid bg-{Darkness.LIGHTEST}-{color_class}">
  <div class="container-xxl flex-grow-1">
    <div class="row details">
      <div class="col-12 text-break">
        <h1 class="text-primary-{color_class}">{title}</h1>
        <div class="row metrics-container">
          {#each resultsSection.metrics as metric}
            {#if metric.project_description_metrics_id && metric.project_description_metrics_id.translations[0]}
              <div class="col-12 col-md-6 col-lg-4 col-xl-3">
                <Metric
                  description={metric.project_description_metrics_id.translations[0]
                    .title}
                  value={metric.project_description_metrics_id.value}
                  unit={metric.project_description_metrics_id.translations[0].unit}
                  valueClass="text-primary-{color_class} mb-1"
                  descriptionClass="text-secondary-{color_class} mb-0"
                />
              </div>
            {/if}
          {/each}
        </div>
      </div>
    </div>
  </div>
</div>
